import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import AsyncStorage from "@react-native-async-storage/async-storage";

/** Response shape from POST /auth/token and POST /auth/refresh */
export interface WayupApiAuthResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  refresh_expires_in: number;
  usuario: string;
  perfil: string;
}

interface WayupApiAuthState {
  accessToken: string | undefined;
  refreshToken: string | undefined;
  usuario: string | undefined;
  perfil: string | undefined;
  setFromAuthResponse: (data: WayupApiAuthResponse) => void;
  clearSession: () => void;
}

const initialValues = {
  accessToken: undefined as string | undefined,
  refreshToken: undefined as string | undefined,
  usuario: undefined as string | undefined,
  perfil: undefined as string | undefined
};

export const useWayupApiAuthStore = create<WayupApiAuthState>()(
  persist(
    (set) => ({
      ...initialValues,
      setFromAuthResponse: (data: WayupApiAuthResponse) => {
        set({
          accessToken: data.access_token,
          refreshToken: data.refresh_token,
          usuario: data.usuario,
          perfil: data.perfil
        });
      },
      clearSession: () => set(initialValues)
    }),
    {
      name: "WayupApiAuthStore",
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);

export function clearWayupApiSession(): void {
  useWayupApiAuthStore.getState().clearSession();
}

export default useWayupApiAuthStore;
